import {Signals} from "@/Imports";
import Facade from "@/Facade";
import LocalizedPIXIText from "@localisation/LocalizedPIXIText";
import TweenMax from "gsap";
import Linear from "gsap";
import FormatData from "@/application/FormatData";
import BaseContainer from "@base/container/BaseContainer";
import SpineAnimation from "@base/spineAnimation/SpineAnimation";

export default class MultiplierContainer extends BaseContainer{

  constructor(data) {
    super()
    this.init()
  }

  init(data) {
    Signals.multiplier.add(this.updateMultiplier, this)
    Signals.roundStart.add(this.onRoundStart, this)
    Signals.roundEnd.add(this.onRoundEnd, this)
    Signals.makeBets.add(this.onMakeBets, this)

    Signals.stopFeature.add(this.onStopFeature, this)
    Signals.showfreebets.add(this.onShowfreebets, this)

    this.container = new PIXI.Container()
    this.addChild(this.container)
    this.container.position.set(26, 37)


    this.X = new LocalizedPIXIText('x', Facade.textFactory.getStyle('multiplier'))
    this.X.resolution = 2
    this.container.addChild(this.X)
    this.X.y -=24

    this.multiplierValue = new LocalizedPIXIText('1.00', Facade.textFactory.getStyle('multiplier'))
    this.multiplierValue.resolution = 2
    this.container.addChild(this.multiplierValue)
    this.multiplierValue.x = this.X.width + 10

    this.freebetsValue = new LocalizedPIXIText('+FREEBET', Facade.textFactory.getStyle('multiplier'))
    this.freebetsValue.resolution = 1
    this.addChild(this.freebetsValue)
    this.freebetsValue.y = 30
    this.freebetsValue.pivot.set(this.freebetsValue.width / 2, 0)
    this.freebetsValue.x = -4
    this.freebetsValue.visible = false

    this.anim = new SpineAnimation('multiplierHighLightAnim')
    this.addChild(this.anim)
    this.anim.position.set(-275, -115)
    this.anim.visible = false
    this.visible = false
  }

  updateMultiplier(multiplier) {
    this.multiplierValue.text = FormatData.formatToFixed(Number(multiplier))

    this.multiplierValue.pivot.set(this.multiplierValue.width / 2, this.multiplierValue.height / 2)
    this.X.x = -(this.multiplierValue.width / 2 - 4)


  }

  onRoundStart() {
    this.multiplierValue.text = '1.00'

    this.visible = true
    this.anim.visible = false

    this.container.pivot.set(this.container.width / 2, this.container.height / 2)

    TweenMax.to(this.container.scale, 0.3, {x: 1.2, y: 1.2, yoyo: true, repeat: -1, ease: Linear.ease, update: () => {
        //this.container.pivot.set(this.container.width / 2, this.container.height / 2)
      }})
  }

  onRoundEnd() {
    this.multiplierValue.text = '1.00'
    this.freebetsValue.visible = false

    this.anim.visible = false
    TweenMax.killTweensOf(this.container.scale)
    TweenMax.killTweensOf(this.container)
    this.multiplierValue.text = `${FormatData.formatToFixed(Facade.model.finalMultiplier)}`
    this.container.scale.set(1)
  }

  onMakeBets() {
    this.visible = false
    this.multiplierValue.text = `1.00`
  }

  onShowfreebets(value) {
    if(value == 0) {
      return
    }
   // this.freebetsValue.visible = true

    this.freebetsValue.text = `+FREEBET`
  }

  onStopFeature() {
    this.anim.visible = true
    this.anim.start(['MulHighLightAnim'], [false])
  }

}

